import React from "react";
import InfoUser from "../component/sections/user/InfoUser";
import AllUser from "../component/sections/user/AllUser";
import AllUserDeleted from "../component/sections/user/AllUserDeleted";
import ShowUserInfo from "../component/sections/user/ShowUserInfo";
import middleware from "./middlewares/middleware";
import AddUserCustomerCoWorker from "../component/sections/user/AddUserCustomerCoWorker";
import AllUserCustomerCoWorker from "../component/sections/user/AllUserCustomerCoWorker";
import InfoCustomerCoworker from "../component/sections/user/InfoCustomerCoworker";
import ShowInfoCustomerCoworker from "../component/sections/user/ShowInfoCustomerCoworker";
import marketerRoutes from "./marketer";
import notificationDashboardRoutes from "./notification-dashboard";
import privateNotificationRoutes from "./private-notification";
import AllMobileReplace from "../component/sections/user/replace-mobile/All";
import AddMobileReplace from "../component/sections/user/replace-mobile/Add";
import ListUserReport from "../component/sections/user/manage/ListUserReport";

const userRoutes = [
  {
    path: "/user/info",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <InfoUser />,
        "InfoUser"
      );
    },
    exact: true,
  },
  {
    path: "/user/all",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllUser />,
        "AllUser"
      );
    },
    exact: true,
  },
  {
    path: "/user/all-user-deleted",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllUserDeleted />,
        "AllUserDeleted"
      );
    },
    exact: true,
  },
  {
    path: "/user/show-info-user/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ShowUserInfo />,
        "ShowUserInfo"
      );
    },
    exact: true,
  },
  {
    path: "/user/all-customer-coworker",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllUserCustomerCoWorker />,
        "AllUserCustomerCoWorker"
      );
    },
    exact: true,
  },
  {
    path: "/user/add-customer-coworker",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddUserCustomerCoWorker />,
        "AddUserCustomerCoWorker"
      );
    },
    exact: true,
  },
  {
    path: "/user/info-customer-coworker",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <InfoCustomerCoworker />,
        "InfoCustomerCoworker"
      );
    },
    exact: true,
  },
  {
    path: "/user/customer-coworker-info/:id",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ShowInfoCustomerCoworker />,
        "ShowInfoCustomerCoworker"
      );
    },
    exact: true,
  },
  {
    path: "/user/mobile-replace",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AllMobileReplace />,
        "AllMobileReplace"
      );
    },
    exact: true,
  },
  {
    path: "/user/add-mobile-replace",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <AddMobileReplace />,
        "AddMobileReplace"
      );
    },
    exact: true,
  },
  {
    path: "/user/list-users",
    render: () => {
      return middleware(
        ["isUserLogin", "checkUserPermissions"],
        <ListUserReport />,
        "ListUserReport"
      );
    },
    exact: true,
  },
  ...marketerRoutes,
  ...notificationDashboardRoutes,
  ...privateNotificationRoutes,
];

export default userRoutes;
